import { Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appHidden]',
})
export class HiddenDirective implements OnChanges {
  private initialDisplayValue: string;

  @Input() appHidden: boolean = false;

  constructor(private el: ElementRef) {
    this.initialDisplayValue = el.nativeElement.style.display;
  }

  ngOnChanges() {
    this.el.nativeElement.style.display = this.appHidden
      ? 'none'
      : this.initialDisplayValue;
  }
}
